import styled from 'styled-components'
import { Button, Modal, Select } from 'antd'
import { useEffect, useState } from 'react'
import { PrivacyPolicy } from './privacy-policy'
import { ServiceAgreement } from './service-agreement '
import { useAgreement, useConfirm } from './util'
import { t } from '@/i18n'
const Protocol = props => {
  const { visible, consent, protocolTab } = props
  const [agreement] = useAgreement()
  const [confirm] = useConfirm()
  const [version, setVersion] = useState<any>()
  useEffect(() => {
    if (visible?.visibleShow) {
      agreement({ token: visible.data?.token, user_id: visible.data?.ID })
        .then(res => {
          setVersion(res?.data)
        })
        .catch(err => {})
    }
    setSelectTab(protocolTab)
  }, [visible, protocolTab])
  let [selectTab, setSelectTab] = useState<'privacy' | 'service'>(protocolTab)
  // const tabClickHanlder = (name: 'privacy' | 'service') => () => {
  //   setSelectTab(name)
  // }
  // 显示弹窗
  const handleCancel = () => {
    consent(false)
  }
  const handleOk = () => {
    consent(true)
    confirm()
      .then(res => {})
      .catch(err => {})
  }
  return (
    <Popup
      visible={visible.visibleShow}
      width={1200}
      centered
      bodyStyle={{ height: '600px' }}
      title={
        <div style={{ borderRadius: '12px' }}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-start',
              borderRadius: '12px',
              marginRight: '20px',
              top: '-50px',
            }}
          >
            <div className="header-table">
              <div
                className="tab-item"
                onClick={() => setSelectTab('privacy')}
                style={
                  selectTab === 'privacy'
                    ? { backgroundColor: '#fff', color: '#4238C9' }
                    : undefined
                }
              >
                {t('隐私政策')}
              </div>
              <div
                className="tab-item"
                onClick={() => setSelectTab('service')}
                style={
                  selectTab === 'service'
                    ? { backgroundColor: '#fff', color: '#4238C9' }
                    : undefined
                }
              >
                {t('服务协议')}
              </div>
            </div>
          </div>
          {/* <div style={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
           <div>
             <p className="release_date" style={{ marginBottom: '18px' }}>
               本政策版本发布日期为：【
               {version?.create_time.substring(0, version?.create_time.indexOf('-'))}
               】年【
               {version?.create_time.substring(
                 version?.create_time.indexOf('-') + 1,
                 version?.create_time.indexOf('-', version?.create_time.indexOf('-') + 1),
               )}
               】月【
               {version?.create_time.substring(
                 version?.create_time.lastIndexOf('-') + 1,
                 version?.create_time.indexOf(' '),
               )}
               】日
             </p>
             <div className="release_date">
               <span>当前查看版本：</span>
               {version?.version && (
                 <Select
                   style={{ width: 140, top: -2 }}
                   defaultValue={version?.current_version}
                   onChange={e => {
                     agreement({
                       version: e,
                       token: visible.data?.token,
                       user_id: visible.data?.ID,
                     })
                       .then(res => {
                         setVersion(res?.data)
                       })
                       .catch(err => {})
                   }}
                 >
                   {version?.version.map(item => (
                     <Option value={item} key={item}>
                       {item}
                     </Option>
                   ))}
                 </Select>
               )}
             </div>
           </div>
          </div> */}
        </div>
      }
      onCancel={handleCancel}
      footer={false}
    >
      {selectTab === 'privacy' ? (
        <PrivacyPolicy data={visible.data} privacy={version?.privacy} />
      ) : (
        <ServiceAgreement data={visible.data} service={version?.service} />
      )}
    </Popup>
  )
}
export default Protocol
const Popup = styled(Modal)`
  margin: auto;
  width: 83%;
  height: 600px;
  border-radius: 12px !important;
  z-index: 1;
  .ant-modal-body {
    padding: 12px 0 12px 40px;
  }
  .ant-drawer {
    position: relative;
  }
  .ant-drawer-mask {
    height: 73%;
  }
  .ant-modal-header {
    border-bottom: 0;
  }
  .ant-modal-title {
    text-align: center;
  }
  .header-table {
    width: 400px;
    display: flex;
    border-radius: 8px;
    margin-bottom: 16px;
    height: 36px;
    position: absolute;
    z-index: -1;
    margin-right: 5px;
    top: -35px;
    .tab-item {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;
      background: #d9d9d9;
      color: #666666;
      width: 104px;
      font-size: 16px;
      border-radius: 8px 8px 0px 0px;
      font-weight: bold;
      padding-top: -4px;
    }
  }
  .release_date {
    display: flex;
    justify-content: end;
  }
  .operation {
    margin-top: 16px;
    display: flex;
    justify-content: center;
  }
  .ant-drawer-header {
    border-radius: 8px;
    padding: 24px;
    padding-bottom: 16px;
  }
  .ant-drawer-body {
    padding: 0 24px;
  }
  .ant-drawer-close {
    display: none;
  }
  .ant-modal-footer {
    padding-bottom: 12px;
    border-top: 1px solid #eeecec;
  }
`
